// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-status .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/fi-task-v2-details/task-v2-status/task-v2-status.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[".fi-task-v2-status {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
